import React from 'react';
import PropTypes, { any } from 'prop-types';

import AboutContent from '../AboutContent';
import CoachInfo from '../CoachInfo';
import styles from './TabContentStudent.scss';
import useIsMobile from '../../hooks/useIsMobile';

const TabContentStudent = (props) => {
    const {
        className,
        profileData,
        displayCollegeRecruitingValues,
        isOwnProfile,
        isOverviewTab,
    } = props;

    const { isMobileWidth } = useIsMobile();
    const showAboutSection = isMobileWidth ? isOverviewTab : true;

    return (
        <div className={`tab-content ${className || ''}`}>
            <div className="container">
                <div className="row">
                    <div className={`col-12 col-md-8 mt48 d-none d-md-block`}>
                        <h6 className="text-semi">High School</h6>
                        {props.children ? props.children : 'No Component Provided'}
                    </div>
                    <div className={`col-12 col-md-4`}>
                        {showAboutSection && profileData && (
                            <div>
                                <AboutContent
                                    className={`mt0`}
                                    profileData={profileData}
                                    displayCollegeRecruitingValues={displayCollegeRecruitingValues}
                                />
                            </div>
                        )}
                        <div className={`d-block d-md-none`}>
                            <h6 className="text-semi mt48">High School</h6>
                            {props.children ? props.children : 'No Component Provided'}
                        </div>
                        {profileData && profileData.studentInfo && profileData.studentInfo.coach && profileData.studentInfo.coach.firstName && profileData.studentInfo.coach.lastName ? (
                            <div>
                                <h6 className="text-semi mt48">Primary Contact</h6>
                                <CoachInfo
                                    coach={profileData.studentInfo.coach}
                                />
                            </div>
                        ) : (
                            <>
                                {isOwnProfile && (
                                    <div>
                                        <h6 className="text-semi mt48">Primary Contact</h6>
                                        <a onClick={props.showEditForm} className={`${styles.contactLink}`}>Add Contact Information</a>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

TabContentStudent.propTypes = {
    displayCollegeRecruitingValues: PropTypes.bool,
    isOverviewTab: PropTypes.bool,
    className: PropTypes.string,
    profileData: PropTypes.objectOf(any),
    children: PropTypes.node,
    isOwnProfile: PropTypes.bool,
};

TabContentStudent.defaultProps = {
    displayCollegeRecruitingValues: false,
    isOverviewTab: false,
    className: '',
    profileData: {},
    children: null,
    isOwnProfile: false,
};

export default TabContentStudent;
